(function() {

    'use strict';

    angular.module('itxApp.common')
        .factory('itxCmsUtilsSvc', itxCmsUtilsSvc);
    
    itxCmsUtilsSvc.$inject = [
        'ItxConfigurationSvc', 
        'DUTTI_CONS', 
        'ItxScreenSizeSvc', 
        '$q', 
        'itxAkamaiSvc', 
        'logger', 
        'ItxHeaderFct',
        'ItxTranslateSvc',
        'Category',
        'UserService',
        'crmService',
        'ItxNewsletterSvc',
        'CountryService',
        'cmsLookbookSvc'
    ];

    function itxCmsUtilsSvc(
        ItxConfigurationSvc,
        DUTTI_CONS, 
        ItxScreenSizeSvc, 
        $q, 
        itxAkamaiSvc, 
        logger, 
        ItxHeaderFct,
        ItxTranslateSvc,
        Category,
        UserService,
        crmService,
        ItxNewsletterSvc,
        CountryService,
        cmsLookbookSvc
    ){
        

        var _this = this;

        _this.showProperties = false;
        if(ItxConfigurationSvc.isDebugActive()){
            _this.showProperties = ItxConfigurationSvc.getDebugOptions().properties;
        }

        // USER VIP 
        _this.userIsVip = false;
        _this.userVipCached = false;
        var stringExcludeVip = 'EXCLUDE_VIP';
        var stringShowVip = 'SHOW_VIP';


        // USER FEEL
        _this.userIsFeel = false;
        _this.userFeelCached = false;
        var stringExcludeFeel = 'EXCLUDE_FEEL';
        var stringShowFeel = 'SHOW_FEEL';

        // USER NEWSLETTER

        _this.userNwl = false;
        _this.userNwlCached = false;

        var service = {
            t: t,
            link: link,
            goToCategory: goToCategory,
            filterArrayExclussions: filterArrayExclussions,
            doClick: doClick,
            translateMicrosite: translateMicrosite
        };
        return service;


        
        function doClick(value) {
            if(value){
                if (value.indexOf('URLROOT') > -1) {                    
                    logger.log('KEY: URLROOT ' + value);
                    window.location.href = inditex.iUrlJSON.protocol +'//'+ inditex.iUrlJSON.host + '/' + inditex.iCountryCode.toLowerCase() + '/' + DUTTI_CONS.i_languages[inditex.iLangId].toLowerCase() + value.replace('URLROOT','');
                } else if (value.indexOf('http') > -1) {
                    // Si tiene http redireccionamos 
                    logger.log('KEY: HTTP ' + value);
                    window.location.href = value;
                } else {
                    // Si no tiene http ni @ es una id de categoria
                    logger.log('KEY: Go to category ' + value);
                    goToCategory(value, true);
                }
            } else {
                logger.logError('No existela key: ' + value + ' en el fichero home-STOREID');
            }
        }

        function goToCategory(categoryId, forceOpen) {
                
            if( !_.isInteger(categoryId) && categoryId.indexOf('#') > -1 ){
                var partials = categoryId.split('#');
                var categoryUrl = Category.getCategoryUrl(partials[0]);
                window.location.href = categoryUrl + '#' + partials[1];
                return;
            }

            if (ItxScreenSizeSvc.is('md,lg') || forceOpen) {
                window.location.href = Category.getCategoryUrl(categoryId);
                return;
            } 
                
            var categories = inditex.iCategoryTreeJSON.categories;
            var subcategories=[];
            /**
             * Search in categories
             */
            var category = _.find(categories, function (category) {
                        return (category.id===categoryId);
                    });
            /**
             * Search in subcategories
             */ 
            if(!category){
                for (var i = 0; i < categories.length; i++) {
                    subcategories=categories[i].subcategories;
                    category=_.find(subcategories, function (subcategory) {
                            return (Number(subcategory.id)===Number(categoryId));
                        });

                    if(category){
                        break;
                    }
                }
            }
            /**
             * If category id was not found either in categories nor subcategories 
             * open the first category to avoid errors.
            */                     
            // if(!category){
            //     category=categories[0];
            // }
            // setTimeout(function() {

            //     $rootScope.$apply(function() {
            //         ItxMenuFct.openSideMenu(category);
            //     });

            // }, 50);
        }

        function link(link) {
            var code = DUTTI_CONS.i_stores[inditex.iStoreId];
            var lang = DUTTI_CONS.i_languages[inditex.iLangId];

            if (!code || !lang) {
                return;
            }
            //Base Case
            if (_.isInteger(link)) {

                return link;
            }
            if (_.isString(link)) {

                return link;
            }

            //if not..
            if (link[code]) {
                //if has DuttiStore..

                if (_.isInteger(link[code])) {

                    return this.link(link[code]);
                } else {
                    if (link[code][lang]) { // jshint ignore:line

                    } else {
                        return this.link(link[code]['default']);
                    }
                }

            } else {

                return link['default'];
            }

        
        }

        function filterArrayExclussions(arr) {

            var deferred = $q.defer();
            var promise = deferred.promise;
            var code = DUTTI_CONS.i_stores[inditex.iStoreId];

            if (!code) {

                return;
            }
            itxAkamaiSvc.getDate().then(function(date) {
                
                var result = _.filter(arr, function(el) {
                    
                    if (el.plan) {
                        var init = moment.tz(el.plan.from, 'YYYY-MM-DD HH:mm:ss', el.plan.tz);
                        var end = moment.tz(el.plan.to, 'YYYY-MM-DD HH:mm:ss', el.plan.tz);

                        if (!date) {
                            logger.log('No DATE');
                            return false;
                        }

                        var res = date.isBetween(init, end);
                        
                        if (!res) {
                            return false;
                        }
                    }

                    if (el.exclude) {
                        if (_.includes(el.exclude, code)) {
                            return false;
                        }
                    }
                    
                    if (el.show) {
                        if (_.includes(el.show, code)) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    
                    return true;
                });
                
                if (UserService.isVip()) {
                    _filterCmpByUserVip(result).then(function (newResult) {
                        deferred.resolve(newResult);
                    });
                } else {
                    if(UserService.isAuthenticated()) {
                        _filterCmpByFeelNwl(result).then(function(newResult) {
                            deferred.resolve(newResult);
                        });
                    }
                    else {
                        deferred.resolve(_filterCmpNoVipFeelNwl(result));
                    }
                }                
            });
            return promise;
        }       
        
        // function _hasSetVipCmp(el) {
        //     if(el.showVip && (el.showVip === stringShowVip || el.showVip === stringExcludeVip) ){
        //         return true;
        //     } else {
        //         return false;
        //     }
        // }

        function t(text) {
            if(_this.showProperties){
                return text;
            } else {
                var textTranslate = ItxTranslateSvc.translate(text);
                if(textTranslate.indexOf('???') > -1 && inditex.iPage ==='ItxCategoryPage'){
                    textTranslate = translateMicrosite(text);
                } else if(textTranslate && textTranslate.indexOf('???') > -1){
                    textTranslate = text;
                    logger.logError('No existe traducción para la key: ', text);
                }
                return textTranslate;
            }
        }

        function translateMicrosite (text){
            //Busco por iStoreId
            var code = DUTTI_CONS.i_stores[inditex.iStoreId];
            var lang = DUTTI_CONS.i_languages[inditex.iLangId];
            if (!code || !lang) {
                return text;
            }
            var str = null;

            //if has specific lang for store: DuttiES --> ES
            if (window.translations[code]) {
                //and has lang
                if (window.translations[code][lang]) {
                    if (window.translations[code][lang][text]) {
                        str = window.translations[code][lang][text];
                    } else {
                        if (window.translations[code]['default'] && window.translations[code]['default'][text])
                        //or DuttiES --> default
                            str = window.translations[code]['default'][text]; // jshint ignore:line
                    }

                }
            }
            //Has common lang
            if (!str && window.translations[lang]) {
                if (window.translations[lang][text]) {
                    str = window.translations[lang][text];
                }
            }

            if (!str && window.translations['default'][text]) {
                str = window.translations['default'][text];
            }

            if (!str) {
                //If no string we set the original text
                str = text;
            }

            return str;            
        }

        // PRIVATE

        function _filterCmpByUserVip(result) {
            var deferred = $q.defer();
            if(_this.userVipCached && _this.userIsVip){
                deferred.resolve(_filterCmpVip(result));
            } else if(_this.userVipCached && !_this.userIsVip) {
                deferred.resolve(_filterCmpNoVip(result));
            } else {
                UserService.isVipEnabled().then(function (isVip) {
                    _this.userIsVip = isVip || UserService.getUserIsVip();
                    _this.userVipCached = true;
                    if(_this.userIsVip) {
                        deferred.resolve(_filterCmpVip(result));
                    } else {
                        deferred.resolve(_filterCmpNoVip(result));
                    }
                });
            }
            
            return deferred.promise;
        }

        function _filterCmpByFeelNwl(result) {
            var deferred = $q.defer();
            if(_this.userFeelCached && _this.userIsFeel) {
                deferred.resolve(_filterCmpFeel(result));
            } else if (_this.userFeelCached && !_this.userIsFeel ) {
                deferred.resolve(_filterCmpNoFeel(result));
            } else if (_this.userNwlCached && _this.userNwl ) {
                deferred.resolve(_filterCmpFeel(result));
            } else if (_this.userNwlCached && !_this.userNwl) {
                deferred.resolve(_filterCmpNoFeel(result));
            }
            else {
                if(crmService.isFeelEnabled()){
                    if(crmService.is360()) {
                        _this.userIsFeel = true;
                        _this.userFeelCached = true;
                        deferred.resolve(_filterCmpFeel(result));
                    } else {
                        deferred.resolve(_filterCmpNoFeel(result));
                    }
                } else {
                    ItxNewsletterSvc.getStatus(inditex.iUserJSON.email)
                        .then(function(suscriptions){
                            _this.userNwl = suscriptions.length > 0;
                            _this.userNwlCached = true;
                            if(_this.userNwl){
                                deferred.resolve(_filterCmpFeel(result));
                            } else {
                                deferred.resolve(_filterCmpNoFeel(result));
                            }
                        });
                }
            }
            return deferred.promise;
        }

        function _filterCmpNoVip(result) {
            return _.filter(result, function (cmp) {
                cmp.iAmVIP = _this.userIsVip;
                return !cmp.showVip || cmp.showVip === stringExcludeVip;
            });
        }

        function _filterCmpNoVipFeelNwl(result) {
            return _.filter(result, function (cmp) {
                if(cmp.showVip) {
                    return !cmp.showVip || cmp.showVip === stringExcludeVip;
                }
                if(cmp.showFeel) {
                    return !cmp.showFeel || cmp.showFeel === stringExcludeFeel;
                }
                return true
            });
        }
        function _filterCmpVip(result){
            return _.filter(result, function (cmp) {
                cmp.iAmVIP = _this.userIsVip;
                return cmp.showVip != stringExcludeVip;
            });
        }

        function _filterCmpNoFeel(result) {
            return _.filter(result, function (cmp) {
                return !cmp.showFeel || cmp.showFeel === stringExcludeFeel;
            });
        }

        function _filterCmpFeel(result){
            return _.filter(result, function (cmp) {
                return cmp.showFeel != stringExcludeFeel;
            });
        }
        
    }

})();